const normalizeFeatureTitle = (value: string) => (value ? value.toLowerCase().replace(/[^a-z0-9]/g, '') : '');

/** TSC+ workbench items that should not appear in navigation or tabs. */
export const isExcludedTscFeatureTitle = (title: string | null | undefined): boolean =>
  normalizeFeatureTitle(title ?? '') === 'llmapplicationevaluation';

export function filterTscDimensions<T extends { dimension_title?: string | null }>(dimensions: T[]): T[] {
  return dimensions.filter(dimension => !isExcludedTscFeatureTitle(dimension.dimension_title));
}

export function filterTscControls<T extends { control_title?: string | null }>(controls: T[]): T[] {
  return controls.filter(control => !isExcludedTscFeatureTitle(control.control_title));
}
